// Checkout click
document.querySelector("#cartFooterCheckout")?.addEventListener("click", async function (e) {
    e.preventDefault();

    // check for note
    let note = document.querySelector("#cartFooterNoteInput").value;
    if (note) {
        await updateCart({note: note})
    }
    window.location.href = `${Shopify.routes.root}checkout`;
});

// countdown timer
function startTimer() {
    timer = setInterval(() => {
        // convert string xx:xx time to MS
        let time = document.querySelector("#cartExpiresTime").innerHTML;
        let splitTime = time.split(':');
        let timeMs = (splitTime[0] * 60000) + (splitTime[1] * 1000);
        // increment time
        if (timeMs > 0) {
            timeMs -= 1000;
        } else {
            // remove timer, stop setInterval
            document.querySelector("#cartExpires").classList.remove('active');

            stopTimer();
        }

        // convert MS to xx:xx format
        let minutes = Math.floor(timeMs / 60000);
        let seconds = ((timeMs % 60000) / 1000).toFixed(0);

        // fix time formatting
        if (seconds < 10) {
            seconds = "0" + seconds
        }
        newTime = minutes + ":" + seconds;
        document.querySelector("#cartExpiresTime").innerHTML = newTime;
    }, 1000);
}

// start timer
if (cart.items.length > 0) {
    startTimer()
}


// stop timer
function stopTimer() {
    clearInterval(timer)
}

// Get active variant for upsell
function getActiveVariant(upsell, product) {

    // collect options from inputs
    let options = [];
    upsell.querySelectorAll(`.cartBodyItemProductTxtSelect`).forEach(group => {
        options.push(group.value);
    });

    // find new variant based on the options
    let activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // default only fallback
    if (upsell.dataset.default === "true") {
        activeVariant = product.variants[0];
    }

    return activeVariant;
}

// listen for upsell change
document.querySelectorAll('.cartBodyItemProductTxtSelect')?.forEach(function (element) {
    element.addEventListener('change', function () {
        let upsell = this.closest('.cartBodyItem');
        let product = productIDtoProduct[upsell.dataset.id];
        let activeVariant = getActiveVariant(upsell, product);

        // update price
        upsell.querySelector('.cartBodyItemSingleReal').textContent = price(activeVariant.price);

        upsell.querySelector('.cartBodyItemSingleCompare').classList.remove('active');
        if (activeVariant.compare_at_price > activeVariant.price) {
            upsell.querySelector('.cartBodyItemSingleCompare').classList.add('active');
            upsell.querySelector('.cartBodyItemSingleCompare').textContent = price(activeVariant.compare_at_price);
        }

    });
});

// Upsell ATC
document.querySelectorAll('.cartBodyItemQuantity.wide')?.forEach(function (element) {
    element.querySelector('.cartBodyItemQuantityPlus').addEventListener('click', async function () {
        let upsell = this.closest('.cartBodyItem');
        let product = productIDtoProduct[upsell.dataset.id];
        let activeVariant = getActiveVariant(upsell, product);

        // add loading
        this.classList.add('loading');

        // add product to cart
        let formData = {
            quantity: 1,
            id: activeVariant.id
        }
        await addProduct(formData);

        // remove loading
        this.classList.remove('loading');

        // open cart
        window.location.href = '/cart';

    });
});